import {
    ADD_TEAM_BY_ADMIN_REQUEST,
    ADD_TEAM_BY_ADMIN_SUCCESS,
    ADD_TEAM_BY_ADMIN_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const addTeamByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_TEAM_BY_ADMIN_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case ADD_TEAM_BY_ADMIN_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ADD_TEAM_BY_ADMIN_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default addTeamByAdminReducer;
